import { FC, useState, useEffect, Fragment } from 'react';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setEntryTime } from 'store/player/playerSlice';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectUserId } from 'store/auth/authSelectors';
import { selectPreviewPageMode } from 'store/player/playerSelectors';
// Components
import PoweredBy from 'components/PoweredBy';
import AppBar from 'components/AppBar';

let interval:any = null;
const intervalTime = 1500;

const CountdownPage:FC = () => {
  const dispatch = useAppDispatch();

  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const userId = useAppSelector(selectUserId);
  const previewPageMode = useAppSelector(selectPreviewPageMode);

  const navigateTo = useNavigateTo()

  const [ countdown, setCountdown ] = useState(3);

  const handleClearInterval = () => {
    if ( interval ) clearInterval(interval);
  }

  const redirectToRegister = !!quiz?.registrationPage && quiz?.registrationPage.showPriorQuiz && !userId;

  useEffect(() => {
    if ( !quiz || previewPageMode ) return;

    if (redirectToRegister) {
      navigateTo('register');
      return;
    }

    if ( !quiz.countdownPage?.enabled ){
      dispatch(setEntryTime(new Date().getTime()));
      navigateTo('pages-handler');
    } else {
      handleClearInterval();
  
      interval = setInterval(() => {
        setCountdown((prevState:number) => prevState - 1);
      }, intervalTime);
    }

    return () => {
      handleClearInterval();
    }
    // eslint-disable-next-line
  }, [userId]);

  useEffect(() => {
    if ( countdown === 0 ){
      dispatch(setEntryTime(new Date().getTime()));
      handleClearInterval();
      navigateTo('pages-handler');
    };
    // eslint-disable-next-line
  }, [countdown]);

  if (!quiz || !quiz.countdownPage?.enabled) return null;
  return (
    <div
      className="flex-grow flex flex-col justify-between items-center p-4"
      style={{ background: quiz.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '' }}
    >
      <AppBar />
      <div className="pt-6 flex-1 flex flex-col items-center justify-center">
        {!redirectToRegister ? (
          <Fragment>
            <div>
              {quiz.countdownPage?.image ? (
                <img
                  className="relative z-10 mb-4 shadow-primary rounded-lg"
                  src={quiz.countdownPage.image}
                  alt=""
                />
              ) : null}
            </div>
            <div className="flex flex-col items-center text-primary">
              <h3 className="font-bold mb-2 md:mb-8 text-center text-5xl">{quiz.countdownPage?.title}</h3>
              {quiz.countdownPage?.text1 ? (
                <p className="w-10/12 text-center font-bold text-xl">{quiz.countdownPage?.text1}</p>
              ) : null}
              {quiz.countdownPage?.text2 ? (
                <p className="w-10/12 text-xl text-center font-bold mb-2 md:mb-8">{quiz.countdownPage?.text2}</p>
              ) : null}
              <h2 className="font-bold text-[150px] leading-none">{countdown}</h2>
            </div>
          </Fragment>
        ) : null}
      </div>
      <PoweredBy />
    </div>
  )
}

export default CountdownPage;
